/**
 * @internal
 */
import { useMotionValue, useSpring } from 'framer-motion';
import { useCallback, useEffect } from 'react';
const useScrollTo = (scrollTo, scrollElement, direction) => {
    // https://github.com/framer/motion/issues/304
    const motion = useMotionValue(scrollTo);
    const spring = useSpring(motion, {
        velocity: 5,
        damping: 20,
    });
    const reset = useCallback((scrollTo) => {
        var _a;
        const resetValue = scrollTo ||
            (
            // @ts-ignore
            (_a = scrollElement === null || scrollElement === void 0 ? void 0 : scrollElement.current) === null || _a === void 0 ? void 0 : _a[direction]) ||
            scrollElement[direction] ||
            0;
        spring.set(resetValue, false);
        motion.set(resetValue, false);
    }, [direction, motion, scrollElement, spring]);
    const stop = useCallback(() => {
        spring.stop();
    }, [spring]);
    useEffect(() => {
        motion.set(scrollTo, false);
    }, [motion, scrollTo, spring]);
    useEffect(() => {
        const unsubscribe = spring.on('change', (value) => {
            if ('current' in scrollElement && scrollElement.current) {
                scrollElement.current[direction] = value;
            }
            else if (scrollElement) {
                scrollElement[direction] = value;
            }
        });
        return () => {
            unsubscribe();
        };
    }, [direction, motion, scrollElement, spring]);
    return {
        motion,
        spring,
        reset,
        stop,
    };
};
export default useScrollTo;
